import React from 'react';
import { FooterAssistance } from '@europrocurement/flexy-components';
import { useUserContactCard } from '@europrocurement/l2d-modules/modules/Utilisateur';

const FooterAssistanceConnected: React.FunctionComponent = function () {
    const { callUserContactCardModal } = useUserContactCard();

    return <FooterAssistance onContactRequest={callUserContactCardModal} />;
};

export default FooterAssistanceConnected;
